var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacionesHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-muro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-47.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-muro",
    transform: "translate(16.000000, 39.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70828246,6.66671754 L1.45828246,6.66671754 C0.654144297,6.66671754 0,6.01257324 0,5.20828246 L0,1.45828246 C0,0.654144297 0.654144297,0 1.45828246,0 L7.70828246,0 C8.51257324,0 9.16671754,0.654144297 9.16671754,1.45828246 L9.16671754,5.20828246 C9.16671754,6.01257324 8.51257324,6.66671754 7.70828246,6.66671754 Z M1.45828246,1.25 C1.34338379,1.25 1.25,1.34338379 1.25,1.45828246 L1.25,5.20828246 C1.25,5.32333375 1.34338379,5.41671754 1.45828246,5.41671754 L7.70828246,5.41671754 C7.82333375,5.41671754 7.91671754,5.32333375 7.91671754,5.20828246 L7.91671754,1.45828246 C7.91671754,1.34338379 7.82333375,1.25 7.70828246,1.25 L1.45828246,1.25 Z",
    id: "Shape",
    fill: "#0063A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70828246,20 L1.45828246,20 C0.654144297,20 0,19.3458557 0,18.5417175 L0,9.79171754 C0,8.98742676 0.654144297,8.33328246 1.45828246,8.33328246 L7.70828246,8.33328246 C8.51257324,8.33328246 9.16671754,8.98742676 9.16671754,9.79171754 L9.16671754,18.5417175 C9.16671754,19.3458557 8.51257324,20 7.70828246,20 Z M1.45828246,9.58328246 C1.34338379,9.58328246 1.25,9.67666625 1.25,9.79171754 L1.25,18.5417175 C1.25,18.6566162 1.34338379,18.75 1.45828246,18.75 L7.70828246,18.75 C7.82333375,18.75 7.91671754,18.6566162 7.91671754,18.5417175 L7.91671754,9.79171754 C7.91671754,9.67666625 7.82333375,9.58328246 7.70828246,9.58328246 L1.45828246,9.58328246 Z",
    id: "Shape",
    fill: "#0063A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417175,20 L12.2917175,20 C11.4874268,20 10.8332825,19.3458557 10.8332825,18.5417175 L10.8332825,14.7917175 C10.8332825,13.9874268 11.4874268,13.3332825 12.2917175,13.3332825 L18.5417175,13.3332825 C19.3458557,13.3332825 20,13.9874268 20,14.7917175 L20,18.5417175 C20,19.3458557 19.3458557,20 18.5417175,20 L18.5417175,20 Z M12.2917175,14.5832825 C12.1766662,14.5832825 12.0832825,14.6766663 12.0832825,14.7917175 L12.0832825,18.5417175 C12.0832825,18.6566162 12.1766662,18.75 12.2917175,18.75 L18.5417175,18.75 C18.6566162,18.75 18.75,18.6566162 18.75,18.5417175 L18.75,14.7917175 C18.75,14.6766663 18.6566162,14.5832825 18.5417175,14.5832825 L12.2917175,14.5832825 Z",
    id: "Shape",
    fill: "#0063A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417175,11.6667175 L12.2917175,11.6667175 C11.4874268,11.6667175 10.8332825,11.0125732 10.8332825,10.2082825 L10.8332825,1.45828246 C10.8332825,0.654144297 11.4874268,0 12.2917175,0 L18.5417175,0 C19.3458557,0 20,0.654144297 20,1.45828246 L20,10.2082825 C20,11.0125732 19.3458557,11.6667175 18.5417175,11.6667175 L18.5417175,11.6667175 Z M12.2917175,1.25 C12.1766662,1.25 12.0832825,1.34338379 12.0832825,1.45828246 L12.0832825,10.2082825 C12.0832825,10.3233337 12.1766662,10.4167175 12.2917175,10.4167175 L18.5417175,10.4167175 C18.6566162,10.4167175 18.75,10.3233337 18.75,10.2082825 L18.75,1.45828246 C18.75,1.34338379 18.6566162,1.25 18.5417175,1.25 L12.2917175,1.25 Z",
    id: "Shape",
    fill: "#0063A6",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacionesHover);
export default __webpack_public_path__ + "static/media/notificaciones-hover.252d3bb239d644594f9d984b08616c16.svg";
export { ForwardRef as ReactComponent };